export default function (mortgage, config) {
    let map = {}
    let errors = []

    map['applicant-names'] = mortgage.applicationTitle
    map['applicant-address'] = (!mortgage.twoApplicants || mortgage.requirement.cohabiting) ? mortgage.applicant1.personal.addressCurrent : mortgage.applicant1.personal.addressCurrent + '\n' + mortgage.applicant2.personal.addressCurrent
    if (!mortgage.activeSubmission?.mortgageAccountNo) {
        errors.push('Mortgage account number is required')
    } else {
        map['application-ref'] = mortgage.activeSubmission?.mortgageAccountNo
    }
    if (!mortgage.requirement?.gifters) {
        errors.push('Missing Gifters')
    } else {
        const allGifters = JSON.parse(mortgage.requirement.gifters)
        const gifterNames = allGifters.map(gifter => gifter.fullName).join(', ')
        const relationships = allGifters.map(gifter => gifter.relationship).join(', ')
        map['gifters-names'] = gifterNames
        map['gifter-address'] = ''
        map['gifter-relationship'] = relationships

    }
    if (!mortgage.property?.address) {
        errors.push('Mortgage address is required')
    } else {
        map['property-address'] = mortgage.property?.address
    }
    return {sections: [{map, errors}]}
}